<div id="chat-widget-username" x-data="usernameForm">
    <form id="chat-widget-username-form" class="chat-widget-username-form"
          @submit.prevent="submitForm">
        <div class="chat-widget-username-form-element">
            <div class="chat-widget-username-header-text">
                <p x-text="usernameSubHeader"></p>
            </div>
            <div class="chat-widget-username-form-element-fields input-container">
                <div class="form-element">
                    <input type="radio" id="chat-widget-gender-male" name="gender" value="Herr" x-model="gender">
                    <label for="chat-widget-gender-male">Herr</label>

                    <input type="radio" id="chat-widget-gender-female" name="gender" value="Frau" x-model="gender">
                    <label for="chat-widget-gender-female">Frau</label>
                </div>

                <div class="form-element">
                    <label for="chat-widget-firstname">Vorname:</label><br>
                    <input type="text"
                           id="chat-widget-firstname"
                           :placeholder="placeholderFirstname"
                           class="input input-text"
                           autocomplete="off"
                           aria-autocomplete="list"
                           aria-haspopup="true"
                           maxlength="50"
                           x-model="firstname">

                    <label for="chat-widget-lastname">Nachname: <span>*</span></label><br>
                    <input type="text"
                           id="chat-widget-lastname"
                           :placeholder="placeholderLastname"
                           class="input input-text"
                           autocomplete="off"
                           aria-autocomplete="list"
                           aria-haspopup="true"
                           maxlength="50"
                           x-model="lastname">
                    <template x-if="validationErrors.lastname">
                        <p id="chat-widget-username-form-error-lastname" class="chat-widget-username-form-error" x-text="validationErrors.lastname">
                        </p>
                    </template>
                </div>

                <div class="form-element">
                    <input type="checkbox" id="chat-widget-agreement" x-model="isAgreementChecked">
                    <label for="chat-widget-agreement">Ich habe die <a href="#">Nutzungsbedingungen</a> zur Kenntnis genommen und akzeptiere diese. <span>*</span></label>
                <template x-if="validationErrors.agreement">
                    <p id="chat-widget-username-form-error-agreement" class="chat-widget-username-form-error" x-text="validationErrors.agreement"></p>
                </template>
                </div>
            </div>
        </div>
        <button type="submit"
                title="Submit"
                id="send-username-button"
                class="chat-widget-button chat-widget-username-button">
            Chat starten
        </button>
    </form>

</div>